import { useState, useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/notice-groups/NoticeGroupsAction";
import { redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { NoticeGroupEditForm } from "./NoticeGroupEditForm";

export function NoticeGroupEdit({
  history,
  match: {
    params: { id }
  }
}) {
  const [title, setTitle] = useState("");  
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, noticeGroup } = useSelector(
    (state) => ({
      actionsLoading: state.noticeGroups.actionsLoading,
      isSuccess: state.noticeGroups.isSuccess,
      type: state.noticeGroups.type,
      noticeGroup: state.noticeGroups.noticeGroup,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getNoticeGroup(id));
    return () => dispatch(actions.cleanNoticeGroupsState());
  }, [id, dispatch]);
  
  useEffect(() => {
    let _title = "Duyuru Grubu";
    let action = id ? "Düzenle" : "Ekle";
    _title += " " + action;
    setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  
  const saveNoticeGroup = (values) => {
    dispatch(actions.saveNoticeGroup(values)).then((result) => onResult(result));
  };
  
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push(`/duyuru-gruplari`), 2500);
  };

  const btnRef = useRef();  
  const saveNoticeGroupClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);
  
  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title} />
      <CardBody>
        <div className="mt-5">          
          <NoticeGroupEditForm 
            noticeGroup={noticeGroup}
            btnRef={btnRef} 
            saveNoticeGroup={saveNoticeGroup}
          />
        </div>        
      </CardBody>
      <CardFooter>
        <div className="offset-sm-2">          
          <button
            type="submit"
            className="btn btn-primary"
            onClick={saveNoticeGroupClick}
          >
            Kaydet
          </button>          
        </div>
      </CardFooter>
    </Card>
  );
}